import Axios from "axios";

export default Axios.create({
  baseURL: "https://jitapi.schoolous.com",
});
// pswd: jit@123#PSWD
// baseURL: 'http://localhost:4000',
//srverUrl: 'https://jitapi.schoolous.com'
